import { connect } from "react-redux";
import { WelcomePage } from "../screens/WelcomePage";
import { callMeBackTrigger } from "../reducers/callMeBack";

function mapStateToProps(state) {
    return { offer: state.offer }
}

function mapDispatchToProps(dispatch) {
    return {
        toggleCallMeBack: ({ isVisible, submitSuccessTrackName, submitStartTrackName }) => {
            dispatch(callMeBackTrigger({ isVisible, submitSuccessTrackName, submitStartTrackName }))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WelcomePage);